// extracted by mini-css-extract-plugin
export default {"root":"DomainList-root_ikg0U","buttonContainer":"DomainList-buttonContainer_XsIl1","button":"DomainList-button_seN22"};